import Marquee from "react-fast-marquee";

const WORDS = ["Sun-cured", "Hand-cut", "Cold-pressed mustard oil", "No preservatives", "Small batch", "Rock salt", "Grandmother's masala"];

export const SpiceMarquee = () => (
  <div className="bg-[#1E1A17] py-6 border-y border-[#3D352F]">
    <Marquee speed={28} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="mx-8 inline-flex items-center gap-8">
          <span className="font-serif italic text-2xl md:text-4xl text-[#F9F6F0]">{w}</span>
          <span className="text-[#E28721] text-2xl">•</span>
        </span>
      ))}
    </Marquee>
  </div>
);
